import { useState } from "react";
import { LoginUser } from "../../Services/Operations/ProductAPI";
import { useDispatch } from "react-redux";
import { setCredentials } from "../../Store/authSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const eyeOpen = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

const eyeClosed = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

const mailIcon = (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const lockIcon = (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);

const Login = () => {

    const dispatch=useDispatch()
    const navigate=useNavigate()
 
   const [email, setEmail] = useState("");
   const [password, setPassword] = useState("");
   const [showPass, setShowPass] = useState(false);
   const [focusEmail, setFocusEmail] = useState(false);
   const [focusPass, setFocusPass] = useState(false);
   const [loading, setLoading] = useState(false);
   const [submitted, setSubmitted] = useState(false);
 
   const handleSubmit =async (e) => {
     e.preventDefault();
     setLoading(true);
     try {
        const res=await LoginUser({email,password})
        console.log(res);
        if(res.status===200){
             setLoading(false);
       setSubmitted(true); 
       toast.success("Loggedin Successfully")
   dispatch(setCredentials({user:res.data.data,token:res.data.token}))
                navigate("/")
        }
        
     } catch (error) {
        console.log(error);
        setLoading(false)
     }
     
   };


 
   const styles = {
     page: {
       minHeight: "100vh",
       background: "#f3f4f6",
       display: "flex",
       alignItems: "center",
       justifyContent: "center",
       fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
       padding: "2rem 1rem",
     },
     card: {
       background: "#ffffff",
       borderRadius: "20px",
       boxShadow: "0 8px 40px rgba(0,0,0,0.10), 0 2px 12px rgba(0,0,0,0.06)",
       padding: "48px 44px 44px",
       width: "100%",
       maxWidth: "420px",
       position: "relative",
     },
     logoMark: {
       width: "44px",
       height: "44px",
       borderRadius: "12px",
       background: "#18181b",
       display: "flex",
       alignItems: "center",
       justifyContent: "center",
       marginBottom: "28px",
     },
     heading: {
       fontSize: "24px",
       fontWeight: "700",
       color: "#111113",
       margin: "0 0 6px",
       letterSpacing: "-0.5px",
     },
     subheading: {
       fontSize: "14px",
       color: "#9ca3af",
       margin: "0 0 36px",
       fontWeight: "400",
     },
     fieldGroup: {
       marginBottom: "16px",
     },
     label: {
       display: "block",
       fontSize: "12.5px",
       fontWeight: "600",
       color: "#374151",
       letterSpacing: "0.04em",
       textTransform: "uppercase",
       marginBottom: "8px",
     },
     inputWrapper: {
       position: "relative",
       display: "flex",
       alignItems: "center",
     },
     inputIcon: {
       position: "absolute",
       left: "14px",
       color: "#9ca3af",
       display: "flex",
       alignItems: "center",
       pointerEvents: "none",
       transition: "color 0.2s",
     },
     input: (focused) => ({
       width: "100%",
       height: "48px",
       border: focused ? "1.5px solid #18181b" : "1.5px solid #e5e7eb",
       borderRadius: "10px",
       background: focused ? "#fafafa" : "#f9fafb",
       padding: "0 14px 0 44px",
       fontSize: "15px",
       color: "#111113",
       outline: "none",
       transition: "border 0.2s, background 0.2s",
       boxSizing: "border-box",
       fontFamily: "inherit",
     }),
     eyeBtn: {
       position: "absolute",
       right: "14px",
       background: "none",
       border: "none",
       cursor: "pointer",
       color: "#9ca3af",
       display: "flex",
       alignItems: "center",
       padding: "0",
     },
     forgot: {
       display: "flex",
       justifyContent: "flex-end",
       marginTop: "8px",
     },
     forgotLink: {
       fontSize: "13px",
       color: "#6b7280",
       textDecoration: "none",
       fontWeight: "500",
       cursor: "pointer",
     },
     submitBtn: {
       width: "100%",
       height: "50px",
       background: loading ? "#52525b" : "#18181b",
       color: "#ffffff",
       border: "none",
       borderRadius: "10px",
       fontSize: "15px",
       fontWeight: "600",
       cursor: loading ? "not-allowed" : "pointer",
       marginTop: "28px",
       letterSpacing: "0.01em",
       transition: "background 0.2s, transform 0.1s",
       display: "flex",
       alignItems: "center",
       justifyContent: "center",
       gap: "8px",
       fontFamily: "inherit",
     },
     divider: {
       display: "flex",
       alignItems: "center",
       gap: "12px",
       margin: "24px 0",
     },
     dividerLine: {
       flex: 1,
       height: "1px",
       background: "#f3f4f6",
     },
     dividerText: {
       fontSize: "12px",
       color: "#d1d5db",
       fontWeight: "500",
     },
     signupRow: {
       textAlign: "center",
       fontSize: "13.5px",
       color: "#9ca3af",
       marginTop: "20px",
     },
     signupLink: {
       color: "#18181b",
       fontWeight: "600",
       textDecoration: "none",
       cursor: "pointer",
       marginLeft: "4px",
     },
     successBadge: {
       textAlign: "center",
       padding: "12px 0 4px",
     },
     successIcon: {
       width: "52px",
       height: "52px",
       borderRadius: "50%",
       background: "#f0fdf4",
       display: "flex",
       alignItems: "center",
       justifyContent: "center",
       margin: "0 auto 16px",
     },
     successTitle: {
       fontSize: "20px",
       fontWeight: "700",
       color: "#111113",
       margin: "0 0 8px",
     },
     successSub: {
       fontSize: "14px",
       color: "#9ca3af",
     },
   };
 
   return (
     <div style={styles.page}>
       <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" />
       <div style={styles.card}>
 
         {/* Logo mark */}
         <div style={styles.logoMark}>
           <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
             <path d="M12 2L2 7l10 5 10-5-10-5z" fill="white" opacity="0.9"/>
             <path d="M2 17l10 5 10-5" stroke="white" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.6"/>
             <path d="M2 12l10 5 10-5" stroke="white" strokeWidth="1.8" strokeLinecap="round" fill="none"/>
           </svg>
         </div>
 
         {submitted ? (
           <div style={styles.successBadge}>
             <div style={styles.successIcon}>
               <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                 <polyline points="20 6 9 17 4 12"/>
               </svg>
             </div>
             <p style={styles.successTitle}>Welcome back!</p>
             <p style={styles.successSub}>You have signed in successfully.</p>
           </div>
         ) : (
           <>
             <h1 style={styles.heading}>Sign in</h1>
             <p style={styles.subheading}>Enter your credentials to continue</p>
 
             <form onSubmit={handleSubmit} autoComplete="off">
               {/* Email */}
               <div style={styles.fieldGroup}>
                 <label style={styles.label}>Email</label>
                 <div style={styles.inputWrapper}>
                   <span style={{ ...styles.inputIcon, color: focusEmail ? "#18181b" : "#9ca3af" }}>
                     {mailIcon}
                   </span>
                   <input
                     type="email"
                     placeholder="you@example.com"
                     value={email}
                     onChange={e => setEmail(e.target.value)}
                     onFocus={() => setFocusEmail(true)}
                     onBlur={() => setFocusEmail(false)}
                     style={styles.input(focusEmail)}
                     required
                   />
                 </div>
               </div>
 
               {/* Password */}
               <div style={styles.fieldGroup}>
                 <label style={styles.label}>Password</label>
                 <div style={styles.inputWrapper}>
                   <span style={{ ...styles.inputIcon, color: focusPass ? "#18181b" : "#9ca3af" }}>
                     {lockIcon}
                   </span>
                   <input
                     type={showPass ? "text" : "password"}
                     placeholder="••••••••"
                     value={password}
                     onChange={e => setPassword(e.target.value)}
                     onFocus={() => setFocusPass(true)}
                     onBlur={() => setFocusPass(false)}
                     style={{ ...styles.input(focusPass), paddingRight: "44px" }}
                     required
                   />
                   <button
                     type="button"
                     style={styles.eyeBtn}
                     onClick={() => setShowPass(v => !v)}
                     tabIndex={-1}
                   >
                     {showPass ? eyeClosed : eyeOpen}
                   </button>
                 </div>
                 <div style={styles.forgot}>
                   <span style={styles.forgotLink}>Forgot password?</span>
                 </div>
               </div>
 
               <button type="submit" style={styles.submitBtn} disabled={loading}>
                 {loading ? (
                   <>
                     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round">
                       <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83">
                         <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.9s" repeatCount="indefinite"/>
                       </path>
                     </svg>
                     Signing in...
                   </>
                 ) : (
                   "Sign in"
                 )}
               </button>
             </form>
 
             <div style={styles.divider}>
               <div style={styles.dividerLine}/>
               <span style={styles.dividerText}>or</span>
               <div style={styles.dividerLine}/>
             </div>
 
             {/* Google SSO */}
             <button style={{
               width: "100%",
               height: "48px",
               background: "#f9fafb",
               border: "1.5px solid #e5e7eb",
               borderRadius: "10px",
               display: "flex",
               alignItems: "center",
               justifyContent: "center",
               gap: "10px",
               fontSize: "14.5px",
               fontWeight: "600",
               color: "#374151",
               cursor: "pointer",
               fontFamily: "inherit",
             }}>
               <svg width="18" height="18" viewBox="0 0 24 24">
                 <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                 <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                 <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                 <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
               </svg>
               Continue with Google
             </button>
 
             <p style={styles.signupRow}>
               Don't have an account?
               <span style={styles.signupLink} onClick={()=>navigate("/register")}>Create one</span>
             </p>
           </>
         )}
       </div>
     </div>
   );
}

export default Login
